// extracted by mini-css-extract-plugin
module.exports = {"cooperation":"cooperation_cooperation__RRcXX","NewBannerPC":"cooperation_NewBannerPC__FdCSO","NewBannerH5":"cooperation_NewBannerH5__FSBq6"};